import EarlyBirdEnrollment from './EarlyBirdEnrollment';
import Referral from './Referral';
import Deposit from './Deposit';

export default class RelatedEntity {
  /**
   * @type {number}
  */
  transactionId;

  /**
   * @type {number}
  */
  officeId;

  /**
   * @type {Deposit}
  */
  deposit;

  /**
   * @type {EarlyBirdEnrollment}
  */
  ebEnrollment;

  /**
   * @type {Referral}
  */
  referral;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.transactionId != null) {
        this.transactionId = opts.transactionId;
      }
      if (opts.officeId != null) {
        this.officeId = opts.officeId;
      }
      if (opts.deposit != null) {
        this.deposit = new Deposit(opts.deposit);
      }
      if (opts.ebEnrollment != null) {
        this.ebEnrollment = new EarlyBirdEnrollment(opts.ebEnrollment);
      }
      if (opts.referral != null) {
        this.referral = new Referral(opts.referral);
      }
    }
  }
}
